import React, { Component } from 'react'
import CommonHeader from '../../navbars/CommonHeader';

// Analysis page header: the shared CommonHeader, in a colour of its own
// (page styles from .erroranalysis-nav).
class ErrorAnalysisNavbar extends Component {
    render() {
        return (
            <CommonHeader className="erroranalysis-nav" color="auto" tone="light" container={false} onToggleSidebar={this.props.onClick} title={"Error Analysis"} />
        )
    }
}

export default ErrorAnalysisNavbar;
